import React, { ReactNode } from 'react';

interface PreviewWithListProps {
  showList: boolean;
  showPreview: boolean;
  listComponent: ReactNode;
  previewComponent: ReactNode;
}

export function PreviewWithList({
  showList,
  showPreview,
  listComponent,
  previewComponent,
}: PreviewWithListProps) {
  return (
    <>
      {showList && listComponent}
      {showPreview && previewComponent}
    </>
  );
}
